import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RelewiseTrackingService } from '@core/services/relewise/relewise-tracking.service';
import { RelewiseMethods } from '@core/services/relewise/relewise.config';
import {
    OthersHaveDoneRecommendationProductsRecommendationResponse as recommendedResponse,
    ProductSearchViewModel,
    ProductSearchViewModelGenericSearchResultViewModel as ProductSearchResult,
    ProductSearchViewModelIEnumerableRecommendationResponse as relewiseResponse
} from '@models/api-search.models';

@Injectable({
    providedIn: 'root'
})
export class RelewiseService {
    constructor(
        private http: HttpClient,
        private relewiseTrackingService: RelewiseTrackingService
    ) {}

    public getLastSeen(autofill: boolean = true): Observable<relewiseResponse> {
        return this.http
            .get<relewiseResponse>(RelewiseMethods.LastSeen, {
                params: this.relewiseTrackingService.getRelewiseTrackingParams({ autofill })
            })
            .pipe(tap(({ temporaryId }) => this.relewiseTrackingService.updateTempId(temporaryId)));
    }

    public getOthersHaveDoneWith(productId: string, autofill: boolean = true): Observable<recommendedResponse> {
        return this.http
            .get<recommendedResponse>(`${RelewiseMethods.OthersHaveDoneWith}${productId}`, {
                params: this.relewiseTrackingService.getRelewiseTrackingParams({ autofill })
            })
            .pipe(tap(({ temporaryId }) => this.relewiseTrackingService.updateTempId(temporaryId)));
    }

    public getMostPopularByBrand(brandId: number, autofill: boolean = true): Observable<relewiseResponse> {
        return this.http
            .get<relewiseResponse>(`${RelewiseMethods.MostPopularByBrand}${brandId}`, {
                params: this.relewiseTrackingService.getRelewiseTrackingParams({ autofill })
            })
            .pipe(tap(({ temporaryId }) => this.relewiseTrackingService.updateTempId(temporaryId)));
    }

    public getMostPopularByCategory(categoryId: number, autofill: boolean = true): Observable<relewiseResponse> {
        return this.http
            .get<relewiseResponse>(`${RelewiseMethods.MostPopularByCategory}${categoryId}`, {
                params: this.relewiseTrackingService.getRelewiseTrackingParams({ autofill })
            })
            .pipe(tap(({ temporaryId }) => this.relewiseTrackingService.updateTempId(temporaryId)));
    }

    public getMostPopular(): Observable<relewiseResponse> {
        return this.http
            .get<relewiseResponse>(RelewiseMethods.MostPopular, {
                params: this.relewiseTrackingService.getRelewiseTrackingParams()
            })
            .pipe(tap(({ temporaryId }) => this.relewiseTrackingService.updateTempId(temporaryId)));
    }

    public getProductsById(productIds: string[]): Observable<ProductSearchResult> {
        return this.http.get<ProductSearchResult>(`${RelewiseMethods.ByProductId}`, {
            params: { include: productIds }
        });
    }

    public getCampaign(campaignId: string, storeId?: number, take: number = 20): Observable<ProductSearchViewModel[]> {
        if (!campaignId) {
            return of<ProductSearchViewModel[]>([]);
        }
        let queryParams = new HttpParams().append('take', take.toString());
        if (storeId) {
            queryParams = queryParams.append('storeId', storeId.toString());
        }
        return this.http.get<ProductSearchViewModel[]>(`${RelewiseMethods.Campaign}${campaignId}/products`, {
            params: queryParams
        });
    }
}
